<template>
	<form @submit.prevent="submitBrokerForm">
		<!-- Broker Name (Required) -->
		<div class="mb-6 relative">
			<label for="broker-name"
				class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Name*
			</label>
			<input type="text" id="broker-name" v-model="broker.name" required placeholder="Name"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Broker Email (Required) -->
		<div class="mb-6 relative">
			<label for="broker-email"
				class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Email
			</label>
			<input type="email" id="broker-email" v-model="broker.email" placeholder="Email"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Broker Mobile -->
		<div class="mb-6 relative">
			<label for="broker-mobile"
				class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Mobile*
			</label>
			<input type="tel" id="broker-mobile" v-model="broker.mobile" required placeholder="Mobile"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- RERA Number -->
		<div class="mb-6 relative">
			<label for="rera-number"
				class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				RERA Number
			</label>
			<input type="text" id="rera-number" v-model="broker.rera_number" placeholder="RERA number"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Firm Name -->
		<div class="mb-6 relative">
			<label for="firm-name" class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Firm Name
			</label>
			<input type="text" id="firm-name" v-model="broker.firm_name" placeholder="Firm Name"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Locality -->
		<div class="mb-6 relative">
			<label for="locality" class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Locality
			</label>
			<input type="text" id="locality" v-model="broker.locality" placeholder="Locality"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Forte -->
		<div class="mb-6 relative">
			<label for="forte" class="text-main text-opacity-80 text-sm block mb-2 bg-white">
				Forte
			</label>
			<input type="text" id="forte" v-model="broker.forte" placeholder="Forte"
				class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
		</div>

		<!-- Submit Button -->
		<div class="mt-10">
			<button type="submit"
				class="bg-primary text-base font-semibold text-white rounded-full p-3 w-full disabled:opacity-50"
				:disabled="!formValid">
				Register Broker
			</button>
		</div>
	</form>
</template>

<script>
export default {
	data() {
		return {
			broker: {
				name: '',
				email: '',
				mobile: '',
				rera_number: '',
				firm_name: '',
				locality: '',
				forte: ''
			}
		}
	},
	computed: {
		formValid() {
			return this.broker.name && this.broker.mobile;
		}
	},
	methods: {
		async submitBrokerForm() {
			try {
				let formData = new FormData();
				formData.append('name', this.broker.name);
				formData.append('email', this.broker.email);
				formData.append('mobile', this.broker.mobile);
				formData.append('rera_number', this.broker.rera_number);
				formData.append('firm_name', this.broker.firm_name);
				formData.append('locality', this.broker.locality);
				formData.append('forte', this.broker.forte);

				const response = await this.$axios.post('mobile_crm/brokers', formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
				this.$emit('broker-submitted', response.data);
				this.broker = {
					name: '',
					email: '',
					mobile: '',
					rera_number: '',
					firm_name: '',
					locality: '',
					forte: ''
				};
			} catch (error) {
				console.error('Error creating broker:', error);
			}
		},
	}
}
</script>